//******************************************************************************
//
//
//
//  #MAIN
//
//
//
//******************************************************************************

(function (Main, window, document, undefined) {
  window.onload = function (event) {
    // Prevent FOUC
    global.html[0].classList.remove("is-dom-loading");

    // Prevent animations and transitions on window resize
    var timerWindowResize;

    window.addEventListener("resize", function () {
      global.html[0].classList.add("is-disable-animations");

      clearTimeout(timerWindowResize);

      timerWindowResize = setTimeout(function () {
        global.html[0].classList.remove("is-disable-animations");
      }, 400);
    });

    // Scroll To
    $(".js-scroll-to").on("click", function (event) {
      event.preventDefault();

      var $this = $(this);
      var target = $this.attr("href");

      $("html, body").animate(
        {
          scrollTop: $(target).offset().top,
        },
        1000
      );
    });

    // Scroll fade in and up
    if ($(".js-scroll-load").length) {
      gsap.utils.toArray(".js-scroll-load").forEach(function (item) {
        var $item = $(item);

        gsap.from($item, {
          duration: 1,
          autoAlpha: 0,
          y: 50,
          scrollTrigger: {
            trigger: item,
            start: "top 90%",
          },
        });
      });
    }

    // Select2
    $(".c-form__select select").select2({
      selectionCssClass: ":all:",
    });

    // Pikaday
    var picker = new Pikaday({
      field: $("#cf7-302-date")[0],
      setDefaultDate: true,
    });

    AgeGate.init();
    BackgroundVideo.init();
    FullPage.init();
    Header.init();
    Menu.init();
    Modal.init();
    PostsList.init();
    Section.init();
    Slider.init();
    Video.init();
  };
})((window.Main = window.Main || {}), window, document);
